export const OVERALL_RESPONSE_BAR_CHART = 'OVERALL RESPONSE BAR CHART';
export const MISCONCEPTIONS_BAR_CHART = 'MISCONCEPTIONS BAR CHART';
export const SUBMISSIONS_VOLUME_BAR_CHART = 'SUBMISSIONS VOLUME BAR CHART';
export const OVERALL_RESPONSE_DISTRIBUTION_BAR_CHART =
  'OVERALL RESPONSE DISTRIBUTION BAR CHART';
export const CO_OCCURRENCE_MISCONCEPTION = 'CO OCCURRENCE MISCONCEPTION';
export const RUBRIC_SCORES_VS_END_OF_YEAR_SCORES =
  'RUBRIC SCORES VS END OF YEAR SCORES';
export const STRATEGY_USE_FREQUENCY = 'STRATEGY USE FREQUENCY';

export const BAR_CHART_WIDTH = 800;
export const BAR_CHART_HEIGHT = 290;

export const WORK_IS_COMPLETE_AND_CORRECT = 'Work is complete and correct';
export const GENERAL_CONCEPTUAL_UNDERSTANDING =
  'General conceptual understanding but work may be insufficient or contain some errors';
export const SIGNIFICANT_ERRORS_IN_WORK = 'Significant errors in work';
export const NO_EVIDENCE_OF_STRATEGY = 'N/A - No evidence of strategy';

export const MISCONCEPTIONS = [
  'Computation Error (e.g., mental math errors)',
  'Precision Error (e.g., wrong units, wrong place value)',
  'Conceptual Misunderstanding (could have multiple)',
  'Representational Error (e.g., not able to draw accurate diagram / model)',
  'Insufficient Explanation (e.g., correct answer, inadequate explanation)',
  "Incomplete (Didn't finish / didn't answer the question)",
  'Unable to Diagnose',
  "Did Not Answer Specific Question (e.g., didn't follow directions)",
  'N/A - No misconception present'
];

type DescriptionsMapper = {
  [key: string]: string;
};

export const CHARTS_DESCRIPTIONS_MAPPER: DescriptionsMapper = {
  [OVERALL_RESPONSE_BAR_CHART]:
    'Highlights how student performance varies by grade, revealing spikes in common error types or conceptual understanding.',
  [MISCONCEPTIONS_BAR_CHART]:
    'Shows the most frequently tagged misconceptions, useful for determining which concepts may need targeted instructional support.',
  [SUBMISSIONS_VOLUME_BAR_CHART]:
    'Helps identify geographic distribution and potential sample bias in the dataset.',
  [OVERALL_RESPONSE_DISTRIBUTION_BAR_CHART]:
    'Surfaces trends across demographic groups—useful for equity-focused research questions.',
  [CO_OCCURRENCE_MISCONCEPTION]:
    'Shows which misconceptions frequently appear together, offering insight into deeper learning gaps.',
  [RUBRIC_SCORES_VS_END_OF_YEAR_SCORES]:
    'Illustrates how student classwork performance (via rubric scores) predicts standardized test outcomes, highlighting the value of classroom data for measuring progress.',
  [STRATEGY_USE_FREQUENCY]:
    'Shows how often students use different problem-solving strategies (e.g., computational, visual), offering insight into how strategy choice relates to learning outcomes.'
};
